import { Link } from 'react-router-dom';
import './introBanner.scss'

interface IntroBannerProps {
  title: string;
  description: string;
}

const IntroBanner: React.FC<IntroBannerProps> = ({ title, description }: IntroBannerProps) => {

  return (
    <div className="container">
      <div className='intro-content'>
        <h1 className='intro-title'>
          {title}
        </h1>
        <p className='intro-text'>
          {description}
        </p>
        <div className='intro-buttons'>
          <Link to="/about">
            <button className='btn learn-more-btn'>
              Learn More
            </button>
          </Link>
          <Link to="/contact">
            <button className='btn banner-contact-us-btn'>
              Contact Us
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default IntroBanner;